__turbopack_context__.v({
  "clientDashboard": "ClientDashboard-module__Uex2bq__clientDashboard",
  "clientDashboardContainer": "ClientDashboard-module__Uex2bq__clientDashboardContainer",
});
